import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';

@Component({
    selector: 'app-color-picker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.css'],
    standalone: false
})
export class ColorPickerComponent {
  @Input() public get value(): cee.Color3Like {
    return this._value;
  }

  @Output() public change = new EventEmitter<cee.Color3Like>();

  public strValue = '';

  private _value!: cee.Color3Like;

  public set value(value: cee.Color3Like) {
    this._value = value;
    this.strValue = this.color3ToHexString(value);
  }

  public colorChanged(strValue: string): void {
    this.strValue = strValue;
    this._value = this.hexStringToColor3(strValue);
    this.change.next(this._value);
  }

  private hexStringToColor3(str: string): cee.Color3Like {
    if (!str) {
      return null as any;
    }
    if (str.charAt(0) === '#') {
      str = str.substr(1);
    }
    if (str.length === 3) {
      str = `${str[0]}${str[0]}${str[1]}${str[1]}${str[2]}${str[2]}`;
    }
    if (str.length !== 6) {
      return null as any;
    }

    const r = str.substr(0, 2);
    const g = str.substr(2, 2);
    const b = str.substr(4, 2);

    return {
      r: parseInt(r, 16) / 255,
      g: parseInt(g, 16) / 255,
      b: parseInt(b, 16) / 255,
    };
  }

  private color3ToHexString(color: cee.Color3Like): string {
    if (!color) {
      return '';
    }

    const r = Math.round(color.r * 255).toString(16);
    const g = Math.round(color.g * 255).toString(16);
    const b = Math.round(color.b * 255).toString(16);
    return `#${r}${g}${b}`;
  }
}
